import { Box, Drawer, useMediaQuery } from '@mui/material';
import { LogoutEnum } from 'core/constants/enums/LogoutEnum.ts';

import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import {
	ACCOUNT,
	API,
	APP,
	CANVASES,
	LOGIN,
	MY_CHARACTERS,
	PRICING,
	ROOT,
	TEXT_TO_IMAGE,
} from 'core/navigation/Routes';
import { googleSignOut } from 'core/store/reducers/appReducer/appSliceThunk';
import React from 'react';
import { useDispatch } from 'react-redux';
import { ReactComponent as Account } from '../../../../assets/svg/app-bar/popover/account.svg';
import { ReactComponent as Credits } from '../../../../assets/svg/app-bar/popover/credits.svg';
import { ReactComponent as Logout } from '../../../../assets/svg/app-bar/popover/logout.svg';
import { ReactComponent as CanvasIcon } from '../../../../assets/svg/canvas-page/canvas.svg';
import { ReactComponent as ApiIcon } from '../../../../assets/svg/navbar/api-icon.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/svg/navbar/cross.svg';
import { ReactComponent as HomeIcon } from '../../../../assets/svg/navbar/home.svg';
import { ReactComponent as MyCharacterIcon } from '../../../../assets/svg/navbar/my-characters.svg';
import { ReactComponent as RenderNet } from '../../../../assets/svg/navbar/rendernet-icon.svg';
import { ReactComponent as TextStudioIcon } from '../../../../assets/svg/navbar/text-to-studio.svg';
import Linked from '../../../../components/link/Link';
import BaseTypography from '../../../../components/typography/BaseTypography';
import FooterNavigationLinksCard from '../../footer-navigation-links-card/FooterNavigationLinksCard';
import ProfileCard from '../../profile-card/ProfileCard';
import { profileButtonStyles } from '../ProfileButtonStyles';

export default function ProfileButtonDrawer({ openDrawer, setOpenDrawer }) {
	const dispatch = useDispatch();

	const currentURL = window.location.href;
	const handleClose = () => {
		setOpenDrawer(false);
	};

	const isSmallScreen = useMediaQuery('(max-width:1300px)');
	return (
		<Drawer
			id="drawer"
			anchor={currentURL.includes(TEXT_TO_IMAGE) ? 'right' : 'left'}
			open={openDrawer}
			onClose={handleClose}
			sx={{ '& .MuiDrawer-paper': { backgroundColor: 'colors.dark6' } }}
		>
			<Box id="drawer-container" sx={[profileButtonStyles.drawerContainer]}>
				<Box sx={reusableStyles.flexColWithGap(24)}>
					<Box sx={[reusableStyles.flexRow, { justifyContent: 'space-between', width: '100%' }]}>
						<RenderNet style={{ color: colorPalette.light2 }} />
						<CloseIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
					</Box>
					<Box sx={{ maxWidth: '248px' }}>
						<ProfileCard />
					</Box>
					<Box
						id="drawer-top-section"
						sx={[
							reusableStyles.flexCol,
							{
								gap: '24px',
								width: { xs: '60%', mm: '54%' },
							},
						]}
					>
						{isSmallScreen && (
							<>
								<Linked to={ROOT}>
									<Box
										sx={[profileButtonStyles.drawer.menuItem]}
										onClick={() => {
											handleClose();
										}}
									>
										<HomeIcon />
										<BaseTypography variant="b1_regular" styles={{ color: 'colors.light3' }}>
											Home
										</BaseTypography>
									</Box>
								</Linked>

								<Box sx={profileButtonStyles.drawer.divider} />

								<Box sx={[reusableStyles.flexCol, { width: '100%', alignItems: 'start' }]}>
									<Box sx={[{ padding: '0 8px 4px' }]}>
										<BaseTypography variant="b2_caption" styles={{ color: 'colors.light5' }}>
											Applications
										</BaseTypography>
									</Box>
									<Linked to={`/${APP}/${TEXT_TO_IMAGE}`}>
										<Box
											sx={[profileButtonStyles.drawer.menuItem]}
											onClick={() => {
												handleClose();
											}}
										>
											<TextStudioIcon />
											<BaseTypography variant="b1_regular" styles={{ color: 'colors.light3' }}>
												Studio
											</BaseTypography>
										</Box>
									</Linked>
									<Linked to={`/${APP}/${CANVASES}`}>
										<Box
											sx={[profileButtonStyles.drawer.menuItem]}
											onClick={() => {
												handleClose();
											}}
										>
											<CanvasIcon />
											<BaseTypography variant="b1_regular" styles={{ color: 'colors.light3' }}>
												Canvas
											</BaseTypography>
										</Box>
									</Linked>
								</Box>

								<Box sx={profileButtonStyles.drawer.divider} />

								<Box sx={[reusableStyles.flexCol, { width: '100%', alignItems: 'start' }]}>
									<Box sx={[{ padding: '0 8px 4px' }]}>
										<BaseTypography variant="b2_caption" styles={{ color: 'colors.light5' }}>
											Explore
										</BaseTypography>
									</Box>
									<Linked to={`/${MY_CHARACTERS}`}>
										<Box
											sx={[profileButtonStyles.drawer.menuItem]}
											onClick={() => {
												handleClose();
											}}
										>
											<MyCharacterIcon />
											<BaseTypography variant="b1_regular" styles={{ color: 'colors.light3' }}>
												Your Characters
											</BaseTypography>
										</Box>
									</Linked>
								</Box>

								<Box sx={profileButtonStyles.drawer.divider} />
							</>
						)}

						<Box sx={[reusableStyles.flexCol, { width: '100%', alignItems: 'start' }]}>
							<Box sx={[{ padding: '0 8px 4px' }]}>
								<BaseTypography variant="b2_caption" styles={{ color: 'colors.light5' }}>
									Profile
								</BaseTypography>
							</Box>

							<Linked to={`/${ACCOUNT}`}>
								<Box
									sx={[profileButtonStyles.drawer.menuItem]}
									onClick={() => {
										handleClose();
									}}
								>
									<Account />
									<BaseTypography variant="b1_regular" styles={{ color: 'colors.light3' }}>
										Account
									</BaseTypography>
								</Box>
							</Linked>
							<Linked to={`/${PRICING}`}>
								<Box
									sx={[profileButtonStyles.drawer.menuItem]}
									onClick={() => {
										handleClose();
									}}
								>
									<Credits />
									<BaseTypography variant="b1_regular" styles={{ color: 'colors.light3' }}>
										Pricing
									</BaseTypography>
								</Box>
							</Linked>
							<Linked to={`/${API}`}>
								<Box
									sx={[profileButtonStyles.drawer.menuItem]}
									onClick={() => {
										handleClose();
									}}
								>
									<ApiIcon />
									<BaseTypography variant="b1_regular" styles={{ color: 'colors.light3' }}>
										Affogato API
									</BaseTypography>
								</Box>
							</Linked>

							{/* might add later */}
							{/* {userProfile.supportEnabled && ( */}
							{/*	<Box */}
							{/*		sx={[profileButtonStyles.drawer.menuItem]} */}
							{/*		onClick={() => { */}
							{/*			window.Intercom('boot', { */}
							{/*				api_base: 'https://api-iam.intercom.io', */}
							{/*				app_id: intercomAppId, */}
							{/*				name: userProfile?.name, */}
							{/*				email: userProfile.email, */}
							{/*				user_type: userProfile?.currentPlan, */}
							{/*			}); */}
							{/*			window.Intercom('show'); */}
							{/*			handleClose(); */}
							{/*		}} */}
							{/*	> */}
							{/*		<ContactSupport /> */}
							{/*		<BaseTypography variant="b1_regular" styles={{ color: 'colors.light3' }}> */}
							{/*			Expert prompt assist */}
							{/*		</BaseTypography> */}
							{/*	</Box> */}
							{/* )} */}

							<Linked to={`/${LOGIN}`}>
								<Box
									sx={[profileButtonStyles.drawer.menuItem]}
									onClick={() => {
										dispatch(googleSignOut(LogoutEnum.USER_LOGGED_OUT));
										handleClose();
									}}
								>
									<Logout />
									<BaseTypography variant="b1_regular" styles={{ color: 'colors.light3' }}>
										Logout
									</BaseTypography>
								</Box>
							</Linked>
						</Box>
					</Box>
				</Box>

				{currentURL.includes(TEXT_TO_IMAGE) && <FooterNavigationLinksCard />}
			</Box>
		</Drawer>
	);
}
